import kt from "./auth-manager.js";
import y from "../common/base-provider.js";
import V from "../util/browser-detector.js";
import Ot from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import {
  isArray as p,
  keys as oo,
  validateValueIsFromEnum as H,
  values as Pt,
} from "../util/code-utils.js";
import { logDeprecationWarning as z } from "../util/deprecation-utils.js";
import Rt from "./network-manager.js";
import Lt from "../request-controller.js";
import Mt from "./server-config-manager.js";
import Dt from "./session-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";
import O, { STORAGE_KEYS as i } from "./storage-manager.js";
import Bt from "./storage-manager-factory.js";
import E from "./subscription-manager.js";
import { TriggersProviderFactory as et } from "../triggers/triggers-provider-factory.js";
import bt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as ct } from "../util/url-utils.js";
import { WindowUtils as Z } from "../util/window-utils.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as P } from "../common/constants.js";
const L = {
  ho: "allowCrawlerActivity",
  Eo: "baseUrl",
  _o: "noCookies",
  Io: "devicePropertyAllowlist",
  Aa: "disablePushTokenMaintenance",
  Ao: "enableLogging",
  So: "enableSdkAuthentication",
  qa: "manageServiceWorkerExternally",
  No: "minimumIntervalBetweenTriggerActionsInSeconds",
  wo: "sessionTimeoutInSeconds",
  Oo: "appVersion",
  Po: "appVersionNumber",
  _a: "serviceWorkerLocation",
  ka: "safariWebsitePushId",
  Ba: "localization",
  po: "contentSecurityNonce",
  Ro: "enableHtmlInAppMessages",
  Co: "allowUserSuppliedJavascript",
  lo: "inAppMessageZIndex",
  fo: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  en: "openNewsFeedCardsInNewTab",
  mh: "requireExplicitInAppMessageDismissal",
  Lo: "doNotLoadFontAwesome",
  Mo: "sdkFlavor",
};
class Wt {
  constructor() {
    (this.cn = ""),
      (this.jo = ""),
      (this.Do = void 0),
      (this.Uo = null),
      (this.fn = null),
      (this.gt = null),
      (this.ki = null),
      (this.wt = null),
      (this._e = null),
      (this.u = null),
      (this.ft = null),
      (this.Bo = ""),
      (this.Wo = !1),
      (this.zo = !1),
      (this.Vo = new E()),
      (this.Go = new E()),
      (this.options = {}),
      (this.Ko = []),
      (this.Ho = []),
      (this.Ve = []),
      (this.jo = "4.10.2");
  }
  $o(t) {
    this.Vo.lt(t);
  }
  Rh(t) {
    this.Go.lt(t);
  }
  initialize(t, s) {
    if (this.fe())
      return (
        r.j.info("Braze has already been initialized with an API key."), !0
      );
    this.options = s || {};
    let e = this.nn(L.Ao);
    const n = ct(Z.Cn());
    if (
      (n && "true" === n.brazeLogging && (e = !0),
      r.j.init(e),
      r.j.info(
        `Initialization Options: ${JSON.stringify(this.options, null, 2)}`,
      ),
      null == t || "" === t || "string" != typeof t)
    )
      return r.j.error("Braze requires a valid API key to be initialized."), !1;
    this.cn = t;
    let o = this.nn(L.Eo);
    if (null == o || "" === o || "string" != typeof o)
      return r.j.error("Braze requires a valid baseUrl to be initialized."), !1;
    !1 === /^https?:/.test(o) && (o = `https://${o}`);
    const h = o;
    if (
      ((o = document.createElement("a")),
      (o.href = h),
      "/" === o.pathname && (o = `${o}api/v3`),
      (this.Bo = o.toString()),
      V.qo && !this.nn(L.ho))
    )
      return (
        r.j.info("Ignoring activity from crawler bot " + navigator.userAgent),
        (this.zo = !0),
        !1
      );
    const a = this.nn(L._o) || !1;
    if (
      ((this.u = Bt.xo(t, a)), a && this.u.Jo(t), new O.ee(null, !0).jr(i.re))
    )
      return (
        r.j.info("Ignoring all activity due to previous opt out"),
        (this.zo = !0),
        !1
      );
    for (const t of oo(this.options))
      -1 === Pt(r.Yo).indexOf(t) &&
        r.j.warn(`Ignoring unknown initialization option '${t}'.`);
    const l = ["mparticle", "wordpress", "tealium"];
    if (null != this.nn(L.Mo)) {
      const t = this.nn(L.Mo);
      -1 !== l.indexOf(t)
        ? (this.Do = t)
        : r.j.error("Invalid sdk flavor passed: " + t);
    }
    let u = this.nn(r.Yo.Io);
    if (null != u)
      if (p(u)) {
        const t = [];
        for (let i = 0; i < u.length; i++)
          H(
            DeviceProperties,
            u[i],
            "devicePropertyAllowlist contained an invalid value.",
            "DeviceProperties",
          ) && t.push(u[i]);
        u = t;
      } else
        r.j.error(
          "devicePropertyAllowlist must be an array. Defaulting to all properties.",
        ),
          (u = null);
    (this.fn = new Ot(this.u, u)),
      (this.wt = new Mt(this.u)),
      (this.ft = new bt(this.wt, this.u)),
      (this._e = new Dt(this.u, this.ft, this.wt, this.nn(L.wo)));
    const f = new E();
    return (
      (this.Uo = new kt(this.u, this.nn(L.So), f)),
      this.jt(f),
      (this.gt = new Rt(
        this.fn,
        this.u,
        this.Uo,
        this.ft,
        this._e,
        this.wt,
        this.cn,
        this.Bo,
        this.jo,
        this.Do || "",
        this.nn(L.Oo),
        this.nn(L.Po),
      )),
      (this.ki = new Lt(
        this.cn,
        this.Bo,
        this._e,
        this.fn,
        this.ft,
        this.wt,
        this.u,
        (t) => {
          if (this.fe()) for (const i of this.gr()) i.Ts(t);
        },
        this.Uo,
        this.gt,
      )),
      this.ki.initialize(),
      r.j.info(
        `Initialized for the Braze backend at "${this.nn(
          L.Eo,
        )}" with API key "${this.cn}".`,
      ),
      null != this.nn(L.Ro) &&
        z(
          "enableHtmlInAppMessages",
          "initialization option",
          "allowUserSuppliedJavascript",
        ),
      et.o(),
      this.wt.Ci(() => {
        this.Wo &&
          this.wt &&
          this.wt.vi() &&
          import("../FeatureFlags/refresh-feature-flags.js").then((t) => {
            if (!this.Wo) return;
            (0, t.default)();
          });
      }),
      this.ki.pr(() => {
        this.Wo &&
          this.wt &&
          this.wt.vi() &&
          import("../FeatureFlags/refresh-feature-flags.js").then((t) => {
            if (!this.Wo) return;
            (0, t.default)(void 0, void 0, !0);
          });
      }),
      this.Vo.Et(this.options),
      (this.Wo = !0),
      !0
    );
  }
  destroy(t) {
    if ((r.j.destroy(), this.fe())) {
      this.Go.Et(), this.Go.removeAllSubscriptions();
      for (const t of this.Ko) t.destroy();
      this.Ko = [];
      for (const t of this.Ho) t.clearData(!1);
      (this.Ho = []),
        this.removeAllSubscriptions(),
        (this.Ve = []),
        null != this.ki && this.ki.destroy(),
        (this.ki = null),
        (this.Uo = null),
        (this.fn = null),
        (this.gt = null),
        (this.wt = null),
        (this._e = null),
        (this.ft = null),
        (this.options = {}),
        (this.Do = void 0),
        (this.Wo = !1),
        (this.zo = !1),
        t && (this.u = null);
    }
  }
  rr() {
    if (this.Xo()) return !1;
    if (!this.fe()) throw new Error(P);
    return !0;
  }
  Ma() {
    return this.cn;
  }
  Sr() {
    return this.Uo;
  }
  Ys() {
    return this.Bo;
  }
  te() {
    return this.fn;
  }
  ar() {
    return this.gt;
  }
  nn(t) {
    return this.options[t];
  }
  gr() {
    return this.Ho;
  }
  cr() {
    return this.ki;
  }
  tr() {
    return this.wt;
  }
  aa() {
    return this._e;
  }
  l() {
    return this.u;
  }
  br() {
    if (this.ft && this.ki) return new User(this.ft, this.ki);
  }
  ir() {
    return this.ft;
  }
  nr() {
    return !0 === this.nn(L.Co) || !0 === this.nn(L.Ro);
  }
  g(t) {
    let i = !1;
    for (const s of this.Ko) s === t && (i = !0);
    i || this.Ko.push(t);
  }
  dr(t) {
    let i = !1;
    for (const s of this.Ho) s.constructor === t.constructor && (i = !0);
    t instanceof y && !i && this.Ho.push(t);
  }
  jt(t) {
    t instanceof E && this.Ve.push(t);
  }
  removeAllSubscriptions() {
    if (this.rr()) for (const t of this.Ve) t.removeAllSubscriptions();
  }
  removeSubscription(t) {
    if (this.rr()) for (const i of this.Ve) i.removeSubscription(t);
  }
  ne(t) {
    this.zo = t;
  }
  fe() {
    return this.Wo;
  }
  Xo() {
    return this.zo;
  }
  ks() {
    return this.jo;
  }
}
const e = new Wt();
export { e as default, Wt as BrazeSdkInstance, L as OPTIONS };
